export const verseButton = document.querySelector('.getVerse');
//export const verseButtonSpan = verseButton.querySelector('.verseText');
export const verseHolder = document.querySelector('.verse div');
export const hiddenVerseHolder = document.querySelector('.hiddenVerseHolder');

export const emailInput = document.querySelector("#email");
export const emailError = document.querySelector("#email-error");
//export const loader = document.querySelector('.loader');
